/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface Role {
  id?: number;
  name: string;
  header: string;
  isSystem?: boolean;
  isReadOnly?: boolean;
  deleted?: boolean;
}

/**
 * Признак «все роли пользователя — только для чтения». Используется для
 * глобального read-only режима админ-UI: true только если массив непустой
 * и КАЖДАЯ роль имеет isReadOnly === true. Любая writable роль выключает
 * режим. Пустой/отсутствующий массив трактуется как «нет ограничений»
 * (false), чтобы не блокировать UI на анонимных/ещё-не-загруженных сессиях.
 */
export function allRolesAreReadOnly(roles: Role[] | null | undefined): boolean {
  return Array.isArray(roles)
    && roles.length > 0
    && roles.every(r => r?.isReadOnly === true);
}
